// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-68afd1ee&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/clients/ExchangeModal.vue
// module id = 442
// module chunks = 0